<template>
    <div class="pin-board row">

        <div v-if="board.trade_arcade_id && !board.is_watchlist" class="col-12 table-summary">
            <div class="d-flex flex-wrap align-items-center">
                <h3 class="mb-0">Trader's Interests:</h3>
                <ul v-for="tag in board.tags" :key="tag.id" class="d-flex mb-0"><li>{{ tag.name }}</li></ul>
            </div>
            <div class="table-summary-note">
                Note: <strong>{{ board.summary }}</strong>
                <a v-if="ulist" href="#" data-bs-toggle="modal" data-bs-target="#name-ta-board" class="edit-table-link"><i class="fa-solid fa-pencil"></i> Edit</a>
            </div>
        </div>

        <div v-if="ulist && (limit > -1 || isMystery || board.trade_arcade_id)" class="col-12">
            <MyListings @addToListings="addListings" @removeFromListings="removeListings" 
                :board-id="board.id" 
                :my-listings="listedPins.filter(p => p.user_id === uid)" 
                :limit="limit"
                :udlist="udlist"
            >List your traders on this table...</MyListings>
        </div>

        <div class="col-md-12 coll-thumbs pin-board-items">
            <div class="row">
                <PinBoardItem
                    v-for="item in listedPins"
                    :key="item.id"
                    :id="item.id"
                    :name="item.name"
                    :title="item.title"
                    :thumb="item.image_pinail"
                    :rarity="item.rarity"
                    :is-traded="!!item.traded"
                    :is-grail="!!item.is_grail"
                    :is-iso="!!item.is_iso"
                    :is-owned="!!item.alreadyOwn"
                    :is-watching="!!item.is_watched"
                    :is-pending-offer="item.pendingOffer && item.pendingOffer !== null"
                    :offers-count="item.offers_count"
                    :is-mine="!!item.is_mine"
                    :is-listing="ulist"
                    :is-mystery="isMystery"
                ></PinBoardItem>
            </div>
        </div>

<!--        <div class="col-12 mt-4">-->
<!--            <nav>-->
<!--                <ul class="pagination justify-content-center">-->
<!--                    <li class="page-item" :class="{disabled: currentPage === 1}"><a @click.prevent="changePage(currentPage-1)" class="page-link" href="#" title="Previous">&lsaquo;</a></li>-->
<!--                    <li v-for="page in Math.ceil(total/perPage)" class="page-item" :class="{disabled: page === currentPage}" :key="page">-->
<!--                        <a v-if="page !== currentPage" @click.prevent="changePage(page)" class="page-link" href="#" :title="'Page ' + page">{{ page }}</a>-->
<!--                        <span v-else class="page-link">{{ page }}</span>-->
<!--                    </li>-->
<!--                    <li class="page-item" :class="{disabled: end >= total}">-->
<!--                        <a @click.prevent="changePage(currentPage+1)" class="page-link" href="#" title="Next">&rsaquo;</a>-->
<!--                    </li>-->
<!--                </ul>-->
<!--            </nav>-->
<!--        </div>-->
    </div>
</template>

<script>
import PinBoardItem from "./PinBoardItem.vue";
import MyListings from "./MyListings.vue";

export default {
    name: 'PinBoard',
    components: {
        PinBoardItem,
        MyListings
    },
    props: {
        board: {
            type: Object,
            required: true
        },
        listings: {
            type: Array,
            required: true
        },
        uid: {
            type: Number,
            required: false,
            default: null
        },
        ulist: {
            type: Boolean,
            default: false
        },
        udlist: {
            type: Boolean,
            default: false
        },
        limit: {
            type: Number,
            default: -1
        }
    },
    data() {
        return {
            listedPins: Vue.util.extend([], this.listings),
            pinIds: this.listings.map(l => l.id),
            isMystery: null,
        }
    },
    computed: {
        //
    },
    methods: {
        getActivity() {
            document.querySelectorAll('.offers-count.active').forEach((el) => el.classList.remove('active'));

            if (this.uid && !this.board.is_watchlist) {
                axios.get('/pin-trading/boards/' + this.board.id + '/offers?listings='+this.pinIds)
                    .then(response => {
                        this.listedPins.forEach((listing) => {
                            if (listing.id in response.data.trades && !listing.traded) {
                                listing.traded = true;
                            }
                            if (listing.id in response.data.offers) {
                                setTimeout(function () {
                                    listing.offers_count = response.data.offers[listing.id];
                                }.bind(this), Math.floor(Math.random() * 20) * 1000);
                            }
                        });
                    }).catch(error => {
                        if (!error.response) {
                            throw error;
                        }
                        if (error.response.status === 401) {
                            window.location.href = '/login?intended='+window.location.pathname;
                        } else if (error.response.status === 419) {
                            window.location.reload();
                        }
                    });
            }
        },

        addListings(listings) {
            listings.forEach(listing => {
                listing.user_id = this.uid;
                this.listedPins.unshift(listing);
            });
        },

        removeListings(listingIds) {
            this.listedPins = this.listedPins.filter(l => !listingIds.find(id => id === l.id));
        }
    },
    mounted() {
        if (!this.ulist) {
            setInterval(function () {
                this.getActivity();
            }.bind(this), 60000);
        }

        if (this.ulist) {
            this.listedPins = this.listedPins.sort((a, b) => a.user_id === this.uid ? -1 : 1);
        }

        this.isMystery = !!this.board.settings && !!this.board.settings.isMystery;
    },
    created() {
        VueEvent.$on('madeTradeOffer', (listingId, traders) => {
            let index = this.listedPins.findIndex(x => x.id === listingId);
            this.listedPins[index].pendingOffer = traders;
        });
    }
}
</script>
